// 商品管理
import api from '../../api'

const state = {
  commodityStatus: [
    {
      value: 1,
      label: '上架'
    },
    {
      value: 0,
      label: '下架'
    }
  ],
  commodityCategory: [],
  commodityNameList: []
}

const getters = {
  commodityStatus: state => state.commodityStatus,
  commodityCategory: state => state.commodityCategory,
  commodityNameList: state => state.commodityNameList
}

const actions = {
  getCommodityCategory ({ commit }) {
    return api.commodity.categoryList({
      pageNum: 1,
      pageSize: 1000
    })
      .then(res => {
        const records = res.data.records || []
        const categories = []
        records.forEach(item => {
          categories.push({
            value: item.id,
            label: item.labelName
          })
        })
        commit('updateCommodityCategory', categories)
        return res
      })
  },
  getCommodityNameList ({ commit }, data) {
    return api.commodity.commodityList(data)
      .then(res => {
        const records = res.data.records || []
        const list = []
        records.forEach(item => {
          list.push({
            value: item.supplierCommodityName,
            label: item.supplierCommodityName,
            supplierCommodityNo: item.supplierCommodityNo,
            costPrice: item.costPrice,
            couponType: item.couponType,
          })
        })
        commit('updateCommodityNameList', list)
        return res
      })
  }
}

const mutations = {
  updateCommodityCategory (state, payload) {
    state.commodityCategory = payload
  },
  updateCommodityNameList (state, payload) {
    state.commodityNameList = payload
  }

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
